import type { Applicant } from "types/application";

/** "First Last" for the header and its applicant dropdown; "" when unnamed. */
export const applicantName = (applicant: Applicant) =>
  [applicant.first_name, applicant.last_name].filter(Boolean).join(" ").trim();
